__turbopack_context__.v({
  "border": "BrowseContainer-module-scss-module__mNHCJW__border",
  "horizontalGutters": "BrowseContainer-module-scss-module__mNHCJW__horizontalGutters",
  "largeMaxWidth": "BrowseContainer-module-scss-module__mNHCJW__largeMaxWidth",
  "root": "BrowseContainer-module-scss-module__mNHCJW__root",
});
